'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { getSessionStorage } from '@cat-ecom/common/utils/storageUtils';
import { replaceTokensInString } from '@cat-ecom/common/utils/stringUtils';
import {
  CatHeading,
  CatIconSuccess,
  CatToast,
  CatToastGroup
} from 'components/blocks-components';
import { PART_NUM_QUANTITY } from 'components/availability-wrapper/dealer-other-branches/constants';

interface StoreLocationToastProps {
  dealerName: string;
}
const StoreLocationToast = ({ dealerName }: StoreLocationToastProps) => {
  const t = useTranslations();
  const [showToaster, setShowToaster] = useState(false);
  const partNumber_QTY = getSessionStorage(PART_NUM_QUANTITY);

  useEffect(() => {
    if (partNumber_QTY) {
      setShowToaster(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {showToaster && (
        <CatToastGroup verticalPosition={'top'} horizontalPosition={'center'}>
          <CatToast variant="success" autoClose={false}>
            <CatIconSuccess slot="before" />
            <CatHeading variant="label">
              {replaceTokensInString(
                t('AVAILABLE_STORE_CHANGE_CONFIRMATION', { 0: dealerName })
              )}
            </CatHeading>
          </CatToast>
        </CatToastGroup>
      )}
    </div>
  );
};

export default StoreLocationToast;
